import angular from 'angular'

import dispatchAsk from './services/ask.service'
import dispatchFormat from './services/format.service'
import dispatchGo from './services/go.service'
import dispatchLocal from './services/local.service'
import dispatchMetadata from './services/metadata.service'
import dispatchNew from './services/new.service'
import dispatchRequest from './services/request.service'
import dispatchResource from './services/resource.service'
import dispatchData from './services/data.service'
import dispatch from './services/dispatch.service'

import myDispatchForm from './directives/forms/myDispatchForm'
import myDispatchCreateForm from './directives/forms/myDispatchCreateForm'
import myDispatchEditForm from './directives/forms/myDispatchEditForm'
import myDispatchSearchForm from './directives/forms/myDispatchSearchForm'
import myDispatchDisplay from './directives/display/myDispatchDisplay'

import dispatchButtons from './resources/buttons.resource'
import dispatchIcons from './resources/icons.resource'
import dispatchFields from './resources/fields.resource'
import dispatchLabels from './resources/labels.resource'

const name = 'dispatch'

angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('dispatchAsk', dispatchAsk)
  .factory('dispatchFormat', dispatchFormat)
  .factory('dispatchGo', dispatchGo)
  .factory('dispatchLocal', dispatchLocal)
  .factory('dispatchMetadata', dispatchMetadata)
  .factory('dispatchNew', dispatchNew)
  .factory('dispatchRequest', dispatchRequest)
  .factory('dispatchResource', dispatchResource)
  .factory('dispatchData', dispatchData)
  .factory('$$dispatch', dispatch)
  // ===== DIRECTIVES ===== //
  .directive('myDispatchForm', myDispatchForm)
  .directive('myDispatchCreateForm', myDispatchCreateForm)
  .directive('myDispatchEditForm', myDispatchEditForm)
  .directive('myDispatchSearchForm', myDispatchSearchForm)
  .directive('myDispatchDisplay', myDispatchDisplay)
  // ===== RESOURCES ===== //
  .factory('dispatchButtons', dispatchButtons)
  .factory('dispatchIcons', dispatchIcons)
  .factory('dispatchFields', dispatchFields)
  .factory('dispatchLabels', dispatchLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/dispatch.module.js